import { useState, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useDeleteTruck() {
  const { uid } = useFirebaseAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const deleteTruck = useCallback(
    async (truckId) => {
      if (!uid) {
        setError(new Error('User not authenticated.'));
        return;
      }
      setLoading(true);
      setError(null);
      setSuccess(false);

      try {
        await API.delete(`/users/${uid}/truck/${truckId}`);
        setSuccess(true);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [uid]
  );

  return { deleteTruck, loading, error, success };
}
